import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from "react";
import { useAuthContext } from "@authentication/context";
import { Paper, Header3, Flex } from "@base-ui";
import { TabMenu } from "@interdependence-ui";
import UploadVideoContent from "./uploadVideo/UploadVideoContent";
import EmbedVideo from "./embedVideo/EmbedVideo";
import { deletePrivateMedia } from "@media";
import { closePopup } from "utils/events";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SelectVideoPopup(props) {
  var content = props.content,
    selectVideo = props.selectVideo;
  var _useState = useState("embed-video"),
    _useState2 = _slicedToArray(_useState, 2),
    currentEntry = _useState2[0],
    setCurrentEntry = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    activeVideo = _useState4[0],
    setActiveVideo = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    description = _useState6[0],
    setDescription = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    activePoster = _useState8[0],
    setActivePoster = _useState8[1];
  var _useAuthContext = useAuthContext(),
    getUserAccess = _useAuthContext.getUserAccess,
    getUser = _useAuthContext.getUser;
  var authTicket = getUser().authTicket;
  var userAccess = getUserAccess();
  if (!userAccess) return null;
  var entries = [{
    id: "upload-video",
    label: "Ladda upp video"
  }, {
    id: "embed-video",
    label: "Bädda in video"
  }];
  var preSelect = function preSelect(newVideo) {
    if (content !== null && content !== void 0 && content.src) deletePrivateMedia(content.src, authTicket);
    closePopup();
    selectVideo(newVideo);
  };
  var uploader = /*#__PURE__*/_jsx(UploadVideoContent, {
    activePoster: activePoster,
    setActivePoster: setActivePoster,
    selectVideo: preSelect,
    activeVideo: activeVideo,
    setActiveVideo: setActiveVideo,
    description: description,
    setDescription: setDescription
  }, "uploader");
  var embedder = /*#__PURE__*/_jsx(EmbedVideo, {
    activeVideo: activeVideo,
    setActiveVideo: setActiveVideo,
    selectVideo: preSelect,
    description: description,
    setDescription: setDescription
  }, "embedder");
  var activeView = currentEntry === "upload-video" ? uploader : embedder;
  var view = !userAccess.media ? /*#__PURE__*/_jsx(Flex.Column, {
    p: "sm",
    children: embedder
  }) : /*#__PURE__*/_jsxs(Flex.Column, {
    p: "sm",
    height: "calc(100% - 40px)",
    children: [/*#__PURE__*/_jsx(TabMenu, {
      id: "select-type-of-video",
      tabs: entries,
      updateSelected: setCurrentEntry,
      selected: currentEntry,
      justifyContent: "center"
    }), activeView]
  });
  return /*#__PURE__*/_jsxs(Paper.Column, {
    width: "470px",
    height: "500px",
    children: [/*#__PURE__*/_jsx(Header3, {
      inverted: true,
      m: "0",
      p: "15px 20px",
      backgroundColor: "P3",
      children: "V\xE4lj video"
    }), view]
  });
}